module.exports = __webpack_public_path__ + "static/media/12-min.8476cd10.jpg";